import { useTranslation } from 'react-i18next';
import { BsPlusCircle } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import classes from './FormButton.module.css';

interface Props {
    redirectUrl: string,
    formExists: boolean
}

const FormButton = ({ redirectUrl, formExists }: Props) => {

    const navigate = useNavigate();

    // Set translation
    const { t } = useTranslation();

    return (
        <div
            className={classes.button}
            onClick={() => navigate(redirectUrl)}
        >
            <BsPlusCircle className={classes.icon} />
            <div className={classes.buttonText}>
                {formExists ? t('assets.formButtonTextFormExists') : t('assets.formButtonText')}
            </div>
        </div>
    )
};

export default FormButton;